<div class="max-w-6xl mx-auto">

  <div class="bg-white shadow rounded-lg p-6 mb-8 text-center">
    <h1 class="text-3xl font-bold mb-2">Gérer les projets</h1>
    <p class="text-gray-600">Ajouter, modifier et supprimer des projets</p>
  </div>

  <div class="bg-white shadow rounded-lg p-8">
    <h2 class="text-xl font-semibold mb-6 text-center">Ajouter un projet</h2>
    <app-projects-form (formSubmit)="onCreate($event)"></app-projects-form>
    <app-projects-table></app-projects-table>

  </div>

</div>